import styled from 'styled-components';

export const Container = styled.div`
  width: 540px;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.div`
  font-size: 24px;
  color: #000;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const WindowButtons = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const WindowButton = styled.div`
  cursor: pointer;
  height: 14px;
  display: flex;
  align-items: flex-end;
  user-select: none;
`;

export const WindowButtonImage = styled.img``;

interface IFormContainer {
  active: boolean;
}

export const FormContainer = styled.div<IFormContainer>`
  display: ${({ active }) => (active ? 'block' : 'none')};
`;
